// extracted by mini-css-extract-plugin
export default {"online_shop_card":"styles_online_shop_card__jkx68","link":"styles_link__gJlfq"};